var map = {
	"./naturalCircle0.svg": "eIUq",
	"./naturalCircle0h.svg": "CHCy",
	"./naturalCircle1.svg": "ZOD0",
	"./naturalCircle1h.svg": "MTxG",
	"./naturalCircle2.svg": "Xm3y",
	"./naturalCircle2h.svg": "v2HR",
	"./naturalCircle3.svg": "gmY2",
	"./naturalCircle3h.svg": "q5iq",
	"./naturalCircle4.svg": "J1/b",
	"./naturalCircle4h.svg": "yrAg",
	"./naturalCircle5.svg": "2EpT",
	"./naturalCircle5h.svg": "Rkro",
	"./naturalCircle6.svg": "95ry",
	"./naturalCircle6h.svg": "NugD",
	"./naturalCircle7.svg": "di45",
	"./naturalCircle7h.svg": "r8YB",
	"./naturalCircle8.svg": "/FQI",
	"./naturalCircle8h.svg": "hAWz",
	"./naturalCircle9.svg": "wtXv",
	"./naturalCircle9h.svg": "/y86"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KSg8";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/naturalCircle.*\.svg$
// module id = KSg8
// module chunks = 1